import { OrderOverview } from 'projects/access-gui/views/orders'

module.exports = [
  {
    path: '/orders',
    exact: true,
    component: OrderOverview
  }
]



// WEBPACK FOOTER //
// ./src/projects/access-gui/routes/orders.js